module.exports = __webpack_public_path__ + "img/Slide9.78b56ce4.png";